import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { FiCalendar, FiX } from "react-icons/fi";
import { FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
registerLocale("es", es);

import { transactionsService } from "services";
import { errorFormating, normalizeDecimal } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import * as rulesActions from 'actions/rulesActions';
import { withTranslation } from 'react-i18next';
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";

class TransactionEdit extends React.Component {

	constructor(props) {
		super(props);
		// console.log(props);

		let transaction = {
			day: '',
			employee_id: '',
			account_id: '',
			observations: ''
		}

		let isEdit = false;
		let isReadOnly = false;
		let operation = 'add';

		if (props.transaction) {
			isEdit = true;
			transaction = props.transaction;
			transaction.employee_id = transaction.employee.id;
			transaction.account_id = transaction.account.id;
			isReadOnly = (transaction.type !== 'Manual') ? true : false

			const numericValue = parseFloat(transaction.value);
			if (!isNaN(numericValue) && numericValue < 0) {
				operation = 'subtract';
				transaction.value = Math.abs(numericValue);
			}
		}

		this.state = {
			isReadOnly,
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			transaction,
			operation,
			new_item_errors: {},
			temp_employee: "",
			temp_employee_candidate: null,
			selected_employees: [],
		};
	}

	employeeSelectFetchOptions = { enabled: true };

	handleChange = event => {
		const { transaction } = this.state;

		let key = event.target.id;
		let value = event.target.value;

		this.setState({
			transaction: {
				...transaction,
				[key]: value
			},
		});
	}

	handleOperationChange = (operation) => {
		this.setState({ operation });
	}

	applyValueSign = (value) => {
		const numericValue = parseFloat(value);
		if (isNaN(numericValue)) return value;
		return this.state.operation === 'subtract'
			? -Math.abs(numericValue)
			: Math.abs(numericValue);
	}

	handleAddChange = (idOrNull, employee) => {
		this.setState({
			temp_employee: idOrNull || "",
			temp_employee_candidate: employee || null,
		});
	};

	handleDateChange = (id, date) => {
		const { transaction } = this.state;

		let key = id;
		let value = date ? moment(date).format("YYYY-MM-DD") : null;

		this.setState({
			transaction: {
				...transaction,
				[key]: value,
			},
		});
	};

	checkValidField = (name) => {
		return (this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '');
	}


	handleSubmit = async event => {
		event.preventDefault();

		this.setState({ isLoading: true });
		let response = '';
		const props = this.props;
		const { transaction, temp_employee, selected_employees } = this.state;

		// if edit => update; else => new
		if (this.state.isEdit) {
			let temp_transaction = { ...transaction };
			temp_transaction.value = normalizeDecimal(temp_transaction.value);
			temp_transaction.value = this.applyValueSign(temp_transaction.value);

			if (isNaN(temp_transaction.value)) {
				this.setState({
					isLoading: false,
					submitted: true,
					errors: { value: this.props.t('transactions.form.valueError') }
				});
				return;
			}

			response = await transactionsService.update(temp_transaction);
		}
		else if (selected_employees.length > 0) {
			// array de transacciones para cada empleado seleccionado
			const transactions = [];
			let hasError = false;

			selected_employees.map((se) => {
				var temp_transaction = { ...transaction };
				temp_transaction.employee_id = se.id;
				temp_transaction.value = normalizeDecimal(temp_transaction.value);
				temp_transaction.value = this.applyValueSign(temp_transaction.value);

				if (isNaN(temp_transaction.value)) {
					hasError = true;
				}

				transactions.push(temp_transaction);
				return true;
			});

			if (hasError) {
				this.setState({
					isLoading: false,
					submitted: true,
					errors: { value: this.props.t('transactions.form.valueError') }
				});
				return;
			}

			response = await transactionsService.addMultiple(transactions);
		}
		else {
			let temp_transaction = { ...transaction };

			if (temp_transaction.employee_id === "" && temp_employee !== undefined)
				temp_transaction.employee_id = temp_employee;

			temp_transaction.value = normalizeDecimal(temp_transaction.value);
			temp_transaction.value = this.applyValueSign(temp_transaction.value);

			if (isNaN(temp_transaction.value)) {
				this.setState({
					isLoading: false,
					submitted: true,
					errors: { value: this.props.t('transactions.form.valueError') }
				});
				return;
			}

			response = await transactionsService.add(temp_transaction);
		}

		//console.log(response);
		if (response.ok) {
			this.setState({
				isLoading: false,
				errors: {},
			}, () => {

				toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
				this.props.getTransactions();
				props.handleClose();

			});
		}
		else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response)
			});
		}

	}


	// employees
	getSelectedEmployees = () => this.state.selected_employees.map((item) => {
		return (
			<li key={item.id} className="tag-default tag-delete" style={{ backgroundColor: item.background_color && item.background_color }}>
				{item.name} {item.surname}
				<button type="button" onClick={() => this.removeEmployee(item.id)} className="btn-tag-delete btn-transparent"><FiX /></button>
			</li>
		)
	});

	addEmployee = () => {
		let { selected_employees, temp_employee, temp_employee_candidate } = this.state;
		let isValid = true;
		let employee;
		const new_item_errors = {};

		if (temp_employee === undefined) {
			isValid = false;
		}
		else {
			employee = temp_employee_candidate;
			if (employee === undefined || employee === null) {
				isValid = false;
				new_item_errors.employee = false;
			}
		}

		if (isValid) {
			// check if day already exists
			const exists = selected_employees.find(item => item.id === parseInt(temp_employee));

			if (!exists) {
				selected_employees = selected_employees.concat(employee);
			}

			this.setState({
				selected_employees,
				new_item_errors: {},
				temp_employee: "",
				temp_employee_candidate: null,
			});
		}
		else {
			this.setState({
				new_item_errors,
			});
		}
	}
	removeEmployee = (idEmployee) => {
		this.setState((prevState, props) => {
			return {
				selected_employees: prevState.selected_employees.filter(item => item.id !== parseInt(idEmployee))
			};
		});
	}

	render() {
		const { isReadOnly, transaction, errors, isEdit, temp_employee, new_item_errors, operation } = this.state;
		const { select_accounts } = this.props;

		const optionAccountList = select_accounts.length > 0 && select_accounts.map((item, i) => {
			return (
				<option key={i} value={item.id}>{item.name}</option>
			)
		}, this);

		return (
			<form className="modal-transaction" >
				<div className="modal-body">

					{isEdit ?
						<FormGroup className="form-group" controlId="employee_id">
							<FormLabel>{this.props.t('transactions.form.employee')} <span className="label-required">*</span></FormLabel>
							<EmployeeSelectSearch
								className="form-select-user"
								controlId="employee_id"
								multiple={false}
								allowClear={false}
								disabled={isReadOnly}
								value={transaction.employee_id ? String(transaction.employee_id) : null}
								onChange={(idOrNull) => {
									this.setState({
										transaction: {
											...transaction,
											employee_id: idOrNull || "",
										},
									});
								}}
								fetchOptions={this.employeeSelectFetchOptions}
								placeholder={this.props.t('transactions.form.selectEmployee')}
								knownEmployee={transaction.employee || null}
							/>

							<FormControl.Feedback type="invalid">
								{errors.employee_id}
							</FormControl.Feedback>
						</FormGroup>
						:
						<div
							className="form-group mb20"
						>
							<p className="mb5 label">{this.props.t('transactions.form.selectEmployees')}</p>

							<div className="flex-group mb10 justify-content-between">
								<FormGroup className="form-group" controlId="temp_employee">
									<EmployeeSelectSearch
										className="form-select-user"
										controlId="temp_employee"
										multiple={false}
										value={temp_employee || null}
										onChange={this.handleAddChange}
										fetchOptions={this.employeeSelectFetchOptions}
										placeholder={this.props.t('common.selectEmployee')}
										allLabel={this.props.t('common.selectEmployee')}
									/>
								</FormGroup>
								<button type="button" onClick={this.addEmployee} className="btn btn-primary">{this.props.t('common.add')}</button>
							</div>
							<ul className="list-tags">
								{this.getSelectedEmployees()}
							</ul>
						</div>
					}


					<FormGroup className="form-group" controlId="account_id">
						<FormLabel>{this.props.t('transactions.form.account')} <span className="label-required">*</span></FormLabel>
						<FormControl
							value={transaction.account_id}
							onChange={this.handleChange}
							placeholder={this.props.t('transactions.form.selectAccount')}
							isInvalid={this.checkValidField('account_id')}
							as="select"
							disabled={isReadOnly}
						>
							<option value="">{this.props.t('transactions.form.selectAccount')}</option>
							{optionAccountList}
						</FormControl>

						<FormControl.Feedback type="invalid">
							{errors.account_id}
						</FormControl.Feedback>
					</FormGroup>

					<Row>
						<Col>
							<FormGroup controlId="day" className={`form-group form-date ${(transaction.day === '' || !transaction.day) && 'empty'}  ${this.checkValidField('day') && "is-invalid"}`}>
								<FormLabel>{this.props.t('transactions.form.date')} <span className="label-required">*</span></FormLabel>

								<DatePicker
									selected={transaction.day === "" || !transaction.day ? transaction.day : moment(transaction.day).toDate()}
									onChange={(date) => this.handleDateChange("day", date)}
									isInvalid={this.checkValidField("day")}
									className="form-control"
									dateFormat="dd/MM/yyyy"
									locale='es'
									placeholderText="dd/mm/aaaa"
									disabled={isReadOnly}
								/>

								<FiCalendar />
								<FormControl.Feedback type="invalid">
									{this.state.errors.day}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col>
							<FormGroup className="form-group" controlId="value">
								<FormLabel>{this.props.t('transactions.form.value')} <span className="label-required">*</span></FormLabel>
								<FormControl
									type="number"
									step="0.01"
									min="0"
									value={transaction.value}
									onChange={this.handleChange}
									placeholder={this.props.t('transactions.form.value')}
									isInvalid={this.checkValidField('value')}
									disabled={isReadOnly}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.value}
								</FormControl.Feedback>
							</FormGroup>
							{!isReadOnly && (
								<div className="modal-transaction__operation-radios">
									<label className="modal-transaction__operation-radio">
										<input
											type="radio"
											name="operation"
											value="add"
											checked={operation === 'add'}
											onChange={() => this.handleOperationChange('add')}
										/>
										<span>{this.props.t('times.balance.manualEntry.addTime')}</span>
									</label>
									<label className="modal-transaction__operation-radio">
										<input
											type="radio"
											name="operation"
											value="subtract"
											checked={operation === 'subtract'}
											onChange={() => this.handleOperationChange('subtract')}
										/>
										<span>{this.props.t('times.balance.manualEntry.subtractTime')}</span>
									</label>
								</div>
							)}
						</Col>
					</Row>
					{!isReadOnly &&
						<FormGroup className="form-group" controlId="observations">
							<FormLabel>{this.props.t('transactions.form.observations')}</FormLabel>
							<FormControl
								type="text"
								value={transaction.observations}
								onChange={this.handleChange}
								placeholder={this.props.t('transactions.form.observations')}
								isInvalid={this.checkValidField('observations')}
								disabled={isReadOnly}
								as="textarea"
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.observations}
							</FormControl.Feedback>
						</FormGroup>
					}

				</div>

				<div className="modal-footer">
					<button type="button" onClick={this.props.handleClose} className="btn btn-outline-primary">{this.props.t('common.cancel')}</button>
					{!isReadOnly && (
						<SubmitButton
							type="button"
							isLoading={this.state.isLoading}
							text={this.props.t('common.save')}
							loadingText={this.props.t('common.saving')}
							onClick={this.handleSubmit}
						/>
					)}
				</div>
			</form>
		)
	}
}


const mapStateToProps = (reducers) => {
	return {
		...reducers.employeesReducer,
		...reducers.rulesReducer,
	}
};
export default connect(mapStateToProps, rulesActions)(withTranslation()(TransactionEdit))